import { render, staticRenderFns } from "./SingleSchool.vue?vue&type=template&id=4e90e793&scoped=true&"
import script from "./SingleSchool.vue?vue&type=script&lang=ts&"
export * from "./SingleSchool.vue?vue&type=script&lang=ts&"
import style0 from "./SingleSchool.vue?vue&type=style&index=0&id=4e90e793&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e90e793",
  null
  
)

export default component.exports